import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { ensureNeighboursInArray } from "/src/helpers/arrayHelpers.js";
import { UspFlag } from "../../components/uspBadge.jsx";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// The hotel image carousel for a search result card. Owns its own slide state.
export default function ResultImageSlider({ images, usp }) {
    const slideCount = images.length;
    const [activeSlide, setActiveSlide] = useState(0);
    const [loadedSlides, setLoadedSlides] = useState(ensureNeighboursInArray(0, slideCount, []));
    let sliderRef = useRef(null);

    const onSlideChange = (next) => {
        setActiveSlide(next);
        setLoadedSlides(ensureNeighboursInArray(next, slideCount, loadedSlides));
    };
    const previousSlide = () => sliderRef.slickPrev();
    const nextSlide = () => sliderRef.slickNext();

    const settings = {
        dots: false,
        lazyLoad: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        beforeChange: (current, next) => onSlideChange(next),
    };

    return (
        <div className="h-full relative overflow-hidden rounded-xl">
            <div className="slider-container h-full">
                <div className="relative ">
                    <UspFlag usp={usp} />
                    <Slider
                        ref={(slider) => {
                            sliderRef = slider;
                        }}
                        {...settings}
                    >
                        {images.map((image, idx) => (
                            <div key={idx}>
                                {loadedSlides.includes(idx) ? (
                                    <img
                                        src={image.imageUrl + "?width=536&height=328"}
                                        alt={image.altText}
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <></>
                                )}
                            </div>
                        ))}
                    </Slider>
                    <div className="slider-indicators">
                        <svg
                            className="absolute right-0 bottom-0 z-[-1] hidden md:block"
                            width="104"
                            height="48"
                            viewBox="0 0 104 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_6059_1066)">
                                <path d="M16 48H0C8.83656 48 16 40.8366 16 32V48Z" fill="white" />
                                <path
                                    d="M104 16L104 6.99382e-07C104 8.83656 96.8366 16 88 16L104 16Z"
                                    fill="white"
                                />
                                <path
                                    d="M16 32C16 23.1634 23.1634 16 32 16H104V48H16V32Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_6059_1066">
                                    <rect width="104" height="48" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <svg
                            className="absolute right-0 bottom-0 z-[-1] block md:hidden"
                            width="36"
                            height="23"
                            viewBox="0 0 36 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_6059_13493)">
                                <path d="M8 23H0.000976562C4.41888 22.9998 8 19.418 8 15V23Z" fill="white" />
                                <path d="M36 8L36 3.49691e-07C36 4.41828 32.4183 8 28 8L36 8Z" fill="white" />
                                <path d="M8 16C8 11.5817 11.5817 8 16 8H36V23H8V16Z" fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_6059_13493">
                                    <rect
                                        width="35.999"
                                        height="23"
                                        fill="white"
                                        transform="translate(0.000976562)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>

                        <button
                            type="button"
                            aria-label="Previous image"
                            className="slider-nav slider-nav-prev hidden md:flex"
                            onClick={previousSlide}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15 18L9 12L15 6"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>

                        <span className="font-medium min-w-[1.875rem] text-[0.625rem] leading-[0.625rem] md:text-xs md:leading-normal text-center">
                            {activeSlide + 1}/{slideCount}
                        </span>

                        <button
                            type="button"
                            aria-label="Next image"
                            className="slider-nav slider-nav-next hidden md:flex"
                            onClick={nextSlide}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9 18L15 12L9 6"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
